import { IGlossarySection } from 'components/glossary/glossary.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { AlgoliaResponseObject } from './algolia.js';

export type ISearchResult = AlgoliaResponseObject;

export interface ISearchResultsGrouped {
  length: number;
  groupedResults: {
    [keyof: string]: ISearchResult[];
  };
}

export enum SearchStatus {
  SEARCHING = 'searching',
}

export interface ISearchState {
  results?: ISearchResultsGrouped;
  searchLabel?: string;
  location?: ILocationSummary;
  relevantLocations: Array<IGlossarySection>;
  searchMCPUrl: string | undefined;
  isSubLocation: boolean;
  displaySearchOverlay: boolean;
  recentSearches: Array<ISearchResult>;
  offsetTop: number;
  searchStatus?: SearchStatus;
}

export const SEARCH_THRESHOLD = 3;

export const RECENT_SEARCHES_MAX = 5;

/** Update key incrementally if we want to clear recent searches  */
export const RECENT_SEARCHES_KEY = 'recent-searches-1';
